import {Document, Image, Page, PDFViewer, Text, View, StyleSheet, Font} from "@react-pdf/renderer";
import {FC} from "react";

const styles = StyleSheet.create({
  paragraph: {
    fontFamily: 'BlinkMacSystemFont',
    fontStyle: 'light',
    lineHeight: 1.714,
  },
  block: {
    fontFamily: 'BlinkMacSystemFont',
    fontStyle: 'light',
    backgroundColor: '#f3f2f8',
    color: '#3888ae',
    borderRadius: 4,
  },
  rowNumber: {
    backgroundColor: '#e2e4e8',
    justifyContent: 'center',
    color: '#8892a5',
    height: 15,
    width: 17,
    textAlign: 'center',
    fontSize: 8
  },
  code: {
    fontFamily: 'SourceCodePro',
    fontStyle: 'regular',
    alignItems: 'center',
    fontSize: 8,
  }
})

type PropsType = {
  companyAPIKey: string;
  propertyId: string;
}

const CodeBlock: FC<PropsType> = ({companyAPIKey, propertyId}) => {
  return (
    <View style={styles.block}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={{borderTopLeftRadius: 4, ...styles.rowNumber}}><Text>1</Text></View>
        <Text style={{marginLeft: 5, ...styles.code}}>{`<div`}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={styles.rowNumber}><Text>2</Text></View>
        <Text style={{marginLeft: 25, ...styles.code}}>{`id="handiscover-accessibility-widget"`}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={styles.rowNumber}><Text>3</Text></View>
        <Text style={{marginLeft: 25, ...styles.code}}>{`class="handiscover-accessibility-widget"`}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={styles.rowNumber}><Text>4</Text></View>
        <Text style={{marginLeft: 25, ...styles.code}}>{`companyId="${companyAPIKey}"`}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={styles.rowNumber}><Text>5</Text></View>
        <Text style={{marginLeft: 25, ...styles.code}}>{`propertyId="${propertyId}"></div>`}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={styles.rowNumber}><Text>6</Text></View>
        <Text style={{marginLeft: 5, ...styles.code}}>{`<link href="https://accessibility-widget.handiscover.com/dist/index.css" rel="stylesheet" />`}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={{borderBottomLeftRadius: 4, ...styles.rowNumber}}><Text>7</Text></View>
        <Text style={{marginLeft: 5, ...styles.code}}>{`<script src="https://accessibility-widget.handiscover.com/dist/index.js"></script>`}</Text>
      </View>
    </View>
  )
}

export default CodeBlock